export enum ViewTypes {
  grid = "grid",
  table = "table",
}
